<template>
  <div class="flex flex-col flex-grow w-full h-full lg:flex-row">
    <!-- Main canvas -->
    <RenderCanvas :preview />

    <!-- Sidebar -->
    <component :is="(!preview) ? ConfigurationSidebar : ConfigurationPreviewSidebar"/>
  </div>
</template>
<script setup lang="ts">
import RenderCanvas from '@/components/RenderCanvas.vue'
import ConfigurationSidebar from '@/components/ConfigurationSidebar.vue'
import ConfigurationPreviewSidebar from './ConfigurationPreviewSidebar.vue'

defineProps<{
  preview: boolean
}>()
</script>
